(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    /* Same money helper as the PDP: prefer Shopify's formatter, fall back to ₺. */
    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '₺' + (cents / 100).toLocaleString('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    document.querySelectorAll('.s81-cart[data-section-id]').forEach((root) => {
      let busy = false;

      /* Push a new quantity for one line to Shopify and re-render totals live.
         quantity 0 removes the line (Shopify standard). */
      function changeLine(lineKey, quantity, lineEl) {
        if (busy) return;
        busy = true;
        root.classList.add('is-updating');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: quantity }),
        })
          .then((r) => r.json())
          .then((cart) => {
            /* If the cart emptied, reload so the empty state renders. */
            if (cart.item_count === 0) {
              window.location.reload();
              return;
            }

            const line = cart.items.find((it) => it.key === lineKey);

            /* Quantity 0 (or line gone) → drop the row from the DOM. */
            if (!line || quantity === 0) {
              if (lineEl) lineEl.remove();
            } else if (lineEl) {
              const priceNow = lineEl.querySelector('.s81-cart__line-price-now');
              if (priceNow) priceNow.textContent = formatMoney(line.final_line_price);
              const input = lineEl.querySelector('[data-qty-input]');
              if (input) input.value = line.quantity;
            }

            /* Update every subtotal / total / count target. */
            const subtotal = formatMoney(cart.items_subtotal_price);
            const total = formatMoney(cart.total_price);

            root.querySelectorAll('.s81-cart__summary-val').forEach((el, i) => {
              if (i === 0) el.textContent = subtotal;
            });
            const headSub = root.querySelector('.s81-cart__head-right-sub');
            if (headSub) headSub.textContent = (root.dataset.tSubtotal || 'Ara toplam') + ' · ' + subtotal;
            const totalEl = root.querySelector('.s81-cart__summary-total');
            if (totalEl) totalEl.textContent = total;
            const checkoutPrice = root.querySelector('.s81-cart__checkout-price');
            if (checkoutPrice) checkoutPrice.textContent = total + ' →';

            const headCount = root.querySelector('.s81-cart__head-right > span');
            if (headCount) {
              var itemsLeftTpl = root.dataset.tItemsLeft || (cart.item_count + ' parça');
              headCount.textContent = itemsLeftTpl.replace('__COUNT__', cart.item_count);
            }
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(() => {
            /* Network/parse failure — fall back to the native form update. */
            const form = root.querySelector('[data-cart-form]');
            if (form) form.submit();
          })
          .finally(() => {
            busy = false;
            root.classList.remove('is-updating');
          });
      }

      root.querySelectorAll('.s81-cart__line-qty').forEach((fieldset) => {
        const input = fieldset.querySelector('[data-qty-input]');
        const minus = fieldset.querySelector('[data-qty-minus]');
        const plus = fieldset.querySelector('[data-qty-plus]');
        if (!input) return;

        const lineEl = fieldset.closest('.s81-cart__line');
        const lineKey = lineEl ? lineEl.getAttribute('data-line-key') : null;

        function commit(qty) {
          const clamped = Math.max(0, qty);
          input.value = clamped;
          if (lineKey) changeLine(lineKey, clamped, lineEl);
        }

        if (minus) {
          minus.addEventListener('click', () => {
            commit((parseInt(input.value, 10) || 0) - 1);
          });
        }
        if (plus) {
          plus.addEventListener('click', () => {
            commit((parseInt(input.value, 10) || 0) + 1);
          });
        }
        /* Typed value: commit on change/blur. */
        input.addEventListener('change', () => {
          commit(parseInt(input.value, 10) || 0);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.s81-collection[data-section-id]').forEach((root) => {
      /* Auto-submit sort select on change */
      const sortSelect = root.querySelector('[data-sort-select]');
      const sortForm = root.querySelector('[data-sort-form]');
      if (sortSelect && sortForm) {
        sortSelect.addEventListener('change', () => {
          sortForm.submit();
        });
      }
    });

    document.addEventListener('click', (e) => {
      const sw = e.target.closest('.s81-collection__sw[data-sw-img]');
      if (!sw) return;
      const card = sw.closest('.s81-collection__card');
      const img = card && (card.querySelector('.s81-collection__shot-pic') || card.querySelector('.s81-collection__shot-img img'));
      if (!img) return;
      img.srcset = sw.dataset.swSrcset || '';
      img.src = sw.dataset.swImg;
      if (sw.dataset.swAlt) img.alt = sw.dataset.swAlt;
      card.querySelectorAll('.s81-collection__sw.is-active').forEach((el) => {
        el.classList.remove('is-active');
      });
      sw.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toastTimer;

    function showToast() {
      var toast = document.getElementById('s81-toast');
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.classList.add('s81-toast--visible');
      toastTimer = setTimeout(function () {
        toast.classList.remove('s81-toast--visible');
      }, 2400);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.s81-products__add-form');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          showToast();
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (btn) btn.disabled = false;
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          form.submit();
        });
    });

    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.s81-products__sw[data-sw-img]');
      if (!sw) return;
      var card = sw.closest('.s81-products__card');
      var img = card && (card.querySelector('.s81-products__shot-pic') || card.querySelector('.s81-products__shot-img img'));
      if (!img) return;
      img.srcset = sw.dataset.swSrcset || '';
      img.src = sw.dataset.swImg;
      if (sw.dataset.swAlt) img.alt = sw.dataset.swAlt;
      card.querySelectorAll('.s81-products__sw.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      sw.classList.add('is-active');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-header"]) return;
  try {
    
  document.addEventListener('cart:updated', (e) => {
    const count = e?.detail?.cart?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  });

  document.querySelectorAll('.s81-header__lang-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-active')) return;
      const form = btn.closest('form');
      const input = form.querySelector('[data-s81-lang-input]');
      input.value = btn.dataset.s81LangCode;
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-pdp-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.s81-pdp[data-section-id]').forEach((root) => {
      let productData = {};
      try {
        productData = JSON.parse(root.dataset.productJson || '{}');
      } catch (_) {
        productData = {};
      }

      const stageImg = root.querySelector('[data-stage-img]');
      const form = root.querySelector('form[data-product-form]');
      const variantInput = form ? form.querySelector('[data-variant-id]') : null;
      const priceEl = root.querySelector('[data-price]');
      const comparePriceEl = root.querySelector('[data-compare-price]');
      const addPriceEl = root.querySelector('[data-add-price]');
      const skuEl = root.querySelector('[data-sku]');
      const skuTagEl = root.querySelector('[data-sku-tag]');
      const addBtn = root.querySelector('[data-add-btn]');
      const addLabel = root.querySelector('[data-add-label]');
      const buyNowBtn = form ? form.querySelector('button[name="checkout"]') : null;
      const variantOptionsTag = root.querySelector('[data-variant-options]');

      const optionCount = (productData.options && productData.options.length) || 0;
      const initialVariant = (productData.variants || []).find((v) => String(v.id) === String(variantInput && variantInput.value));
      const selectedOptions = initialVariant && initialVariant.options ? initialVariant.options.slice() : new Array(optionCount).fill(null);

      /* Size must be chosen explicitly — clear any pre-filled size option so the
         customer cannot add to cart before picking a size. (A4 audit fix) */
      const sizeIndexes = Array.from(
        new Set(
          Array.from(root.querySelectorAll('[data-is-size="true"]'))
            .map((b) => parseInt(b.dataset.optionIndex, 10))
            .filter((n) => !isNaN(n))
        )
      );
      sizeIndexes.forEach((i) => { selectedOptions[i] = null; });
      const sizeMissing = () => sizeIndexes.some((i) => !selectedOptions[i]);

      /* ---- Thumbnails ---- */
      const thumbs = root.querySelectorAll('.s81-pdp__thumb');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.stageSrc;
          const alt = thumb.dataset.stageAlt;
          if (stageImg && src) {
            stageImg.src = src;
            stageImg.removeAttribute('srcset');
            if (alt) stageImg.alt = alt;
          }
          thumbs.forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      /* Varyant görseline geçerken eşleşen thumbnail varsa onun üzerinden git
         (aktiflik durumu + 1200w src); yoksa ham varyant görselini bas. */
      const syncStageImage = (fimg) => {
        if (!fimg || !fimg.src || !stageImg) return;
        const base = fimg.src.split('?')[0];
        let matchedThumb = null;
        thumbs.forEach((t) => {
          if ((t.dataset.stageSrc || '').split('?')[0] === base) matchedThumb = t;
        });
        if (matchedThumb) {
          matchedThumb.click();
        } else {
          stageImg.src = fimg.src;
          stageImg.removeAttribute('srcset');
        }
      };

      /* ---- Money helper ---- */
      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
        const n = (cents / 100).toFixed(2);
        return '₺' + n;
      };

      /* ---- Variant selection ---- */
      const updateForVariant = (variant) => {
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (buyNowBtn) buyNowBtn.disabled = true;
          if (addLabel) addLabel.textContent = sizeMissing() ? (root.dataset.sizePrompt || 'Beden Seçin') : (root.dataset.tNoOption || 'Seçenek Yok');
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addPriceEl) addPriceEl.textContent = formatMoney(variant.price) + ' →';

        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (skuEl) skuEl.textContent = 'SKU ' + (variant.sku || '—');
        if (skuTagEl) skuTagEl.textContent = 'SERİ · ' + (variant.sku || 'S81');

        if (variantOptionsTag && variant.title && variant.title !== 'Default Title') {
          variantOptionsTag.textContent = variant.title.toLocaleUpperCase('tr');
        }

        if (addBtn) addBtn.disabled = !variant.available;
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? (root.dataset.tAddToCart || 'Sepete Ekle') : (root.dataset.tSoldOut || 'Tükendi');

        syncStageImage(variant.featured_image);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      };

      const findVariant = () => {
        if (!productData.variants) return null;
        /* If a size option exists but hasn't been chosen, there is no valid variant yet. */
        if (sizeMissing()) return null;
        return productData.variants.find((v) => {
          if (!v.options) return false;
          for (let i = 0; i < selectedOptions.length; i++) {
            if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
          }
          return true;
        });
      };

      /* A size (or colour) button can look available in isolation while the
         SPECIFIC combination with the currently selected other option(s) has
         no stock — e.g. 6XL exists and sells fine in black, but there is no
         6XL/white variant at all. Recompute every button's real availability
         against the *current* selection instead of trusting the initial,
         color-agnostic server render. */
      const refreshOptionAvailability = () => {
        root.querySelectorAll('[data-option-index]').forEach((btn) => {
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const val = btn.dataset.optionValue;
          const hasMatch = (productData.variants || []).some((v) => {
            if (!v.options || !v.available) return false;
            if (v.options[idx] !== val) return false;
            for (let i = 0; i < selectedOptions.length; i++) {
              if (i === idx) continue;
              if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-oos', !hasMatch);
          btn.disabled = !hasMatch;
          btn.setAttribute('aria-disabled', hasMatch ? 'false' : 'true');
        });
      };
      refreshOptionAvailability();

      root.querySelectorAll('[data-option-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-oos') || btn.disabled) return;
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const val = btn.dataset.optionValue;
          selectedOptions[idx] = val;
          refreshOptionAvailability();

          root.querySelectorAll('[data-option-index="' + idx + '"]').forEach((sib) => {
            sib.classList.remove('is-active');
            sib.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          const display = root.querySelector('[data-option-display="' + idx + '"]');
          if (display) display.textContent = val;

          const variant = findVariant();
          updateForVariant(variant);

          /* Beden seçilmeden renk değiştirilirse tam varyant oluşmaz ama görsel
             ve seçenek etiketi yine de yeni renge geçmeli. Beden yok sayılarak
             seçili renge uyan ilk varyantın görseli kullanılır. */
          if (!variant) {
            const partialMatch = (productData.variants || []).find((v) => {
              if (!v.options) return false;
              for (let i = 0; i < selectedOptions.length; i++) {
                if (sizeIndexes.indexOf(i) !== -1) continue;
                if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
              }
              return true;
            });
            if (partialMatch) syncStageImage(partialMatch.featured_image);
            if (variantOptionsTag) {
              const partialLabel = selectedOptions
                .map((o, i) => o || (sizeIndexes.indexOf(i) !== -1 ? '—' : ''))
                .filter(Boolean);
              if (partialLabel.length) variantOptionsTag.textContent = partialLabel.join(' / ').toLocaleUpperCase('tr');
            }
          }
        });
      });

      /* Apply initial state: if a size is required but not chosen, the button
         starts as a disabled "Beden Seçin" prompt instead of silently adding. */
      if (sizeIndexes.length) {
        updateForVariant(findVariant());
      }

      /* ---- Qty stepper ---- */
      const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      const qtyMinus = root.querySelector('[data-qty-minus]');
      const qtyPlus = root.querySelector('[data-qty-plus]');
      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }

      /* ---- AJAX add-to-cart ---- */
      if (form) {
        form.addEventListener('submit', async (e) => {
          if (e.submitter && e.submitter.name === 'checkout') {
            return; /* native buy-now submit */
          }
          e.preventDefault();
          if (!addBtn || addBtn.disabled) return;
          const originalLabel = addLabel ? addLabel.textContent : '';
          if (addLabel) addLabel.textContent = 'Ekleniyor…';
          addBtn.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new URLSearchParams(new FormData(form)).toString(),
            });
            if (!res.ok) throw new Error('add failed');

            if (addLabel) addLabel.textContent = root.dataset.tAdded || '✓ Sepete Eklendi';

            /* Show the global cart toast (same element the header/featured sections use) */
            const toastEl = document.getElementById('s81-toast');
            if (toastEl) {
              toastEl.classList.add('s81-toast--visible');
              clearTimeout(window.__s81ToastTimer);
              window.__s81ToastTimer = setTimeout(() => {
                toastEl.classList.remove('s81-toast--visible');
              }, 2400);
            }

            setTimeout(() => {
              if (addLabel) addLabel.textContent = originalLabel || root.dataset.tAddToCart || 'Sepete Ekle';
              addBtn.disabled = false;
            }, 1800);

            try {
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            } catch (_) { /* swallow */ }
          } catch (err) {
            if (addLabel) addLabel.textContent = root.dataset.tErrorRetry || 'Hata — Tekrar dene';
            setTimeout(() => {
              if (addLabel) addLabel.textContent = originalLabel || root.dataset.tAddToCart || 'Sepete Ekle';
              addBtn.disabled = false;
            }, 1800);
          }
        });
      }

      /* ---- Zoom button (placeholder; lightbox deferred) ---- */
      const zoomBtn = root.querySelector('[data-zoom]');
      if (zoomBtn && stageImg) {
        zoomBtn.addEventListener('click', () => {
          if (stageImg.src) window.open(stageImg.src, '_blank', 'noopener');
        });
      }
    });
  });

  /* ── Size guide ── */
  (function () {
    var guide = document.getElementById('s81-size-guide');
    if (!guide) return;

    function openGuide() {
      guide.classList.add('is-open');
      guide.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeGuide() {
      guide.classList.remove('is-open');
      guide.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.s81-pdp__opt-help').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openGuide(); });
    });

    guide.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-close]')) closeGuide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && guide.classList.contains('is-open')) closeGuide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s81-pdp-paired"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('[data-products-recommendations]')
      : null;

    if (!root) {
      root = document.querySelector('[data-products-recommendations]:not([data-hydrated])');
    }
    if (!root) return;

    var source = root.querySelector('[data-paired-grid]');
    if (!source) return;
    if (source.getAttribute('data-paired-source') === 'recommendations') {
      root.setAttribute('data-hydrated', 'true');
      return;
    }

    var url = root.getAttribute('data-url');
    if (!url) return;

    root.setAttribute('data-hydrated', 'pending');

    fetch(url)
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-paired-grid]');
        if (incoming && incoming.children.length > 0) {
          source.innerHTML = incoming.innerHTML;
          source.setAttribute('data-paired-source', 'recommendations');
        }
        root.setAttribute('data-hydrated', 'true');
      })
      .catch(function () {
        root.setAttribute('data-hydrated', 'error');
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
